import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_DK.json';
import exercises from './FITNESS_EXERCISES_DK.json';
import recipes from './FITNESS_RECIPES_DK.json';

export const FITNESS_DATA_DK: ServiceData = {
  articles,
  exercises,
  recipes,
};
